angular.module('eatself')
.filter('dashify', function(UrlService) {
  return function(input) {
    return UrlService.dashify(input);
  };
})